import { render, staticRenderFns } from "./assign_participants.vue?vue&type=template&id=028aeed4&"
import script from "./assign_participants.vue?vue&type=script&lang=js&"
export * from "./assign_participants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('028aeed4')) {
      api.createRecord('028aeed4', component.options)
    } else {
      api.reload('028aeed4', component.options)
    }
    module.hot.accept("./assign_participants.vue?vue&type=template&id=028aeed4&", function () {
      api.rerender('028aeed4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/sessions/assign_participants.vue"
export default component.exports